import React, {Component} from 'react';
  
export default class Navigator extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
        isOpen: false
        };
    }
    toggle() {
        this.setState({
        isOpen: !this.state.isOpen
        });
    }
    render() {
        return (
            <div className="terminal-nav">
					<header className="terminal-logo">
						<div className="logo terminal-prompt">
							Brandon Wong
						</div>
					</header>
					<nav className="terminal-menu">
						<ul>
							<li><a href="/">Home</a></li>
							<li><a href="/projects">Projects</a></li>
							<li><a href="/ctf">CTFs</a></li>
						</ul>
					</nav>
				</div>
        );
    }
}
